import { defaultOperators } from "react-querybuilder";

export const nameOperators = defaultOperators.filter((op) =>
  [
    "=",
    "!=",
    "beginsWith",
    "endsWith",
    "contains",
    "doesNotBeginWith",
    "doesNotEndWith",
    "doesNotContain",
    "null",
    "notNull",
  ].includes(op.name),
);
export const numberOperators = defaultOperators.filter((op) =>
  [
    "=",
    "!=",
    ">",
    ">=",
    "<",
    "<=",
    "between",
    "notBetween",
    "null",
    "notNull",
  ].includes(op.name),
);
